import { useState } from 'react';
import { Calendar as BigCalendar, momentLocalizer } from 'react-big-calendar';
import moment from 'moment';
import 'moment/locale/tr';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Badge } from "@/components/ui/badge";

moment.locale('tr');
const localizer = momentLocalizer(moment);

function CalendarView({ tasks, onTaskClick, onSelectSlot }) {
  const [date, setDate] = useState(new Date());
  const [view, setView] = useState('month');

  const priorityColors = {
    "low": "#9CA3AF",
    "medium": "#F59E0B",
    "high": "#EF4444"
  };

  const statusColors = {
    "todo": "#3B82F6",
    "in-progress": "#8B5CF6",
    "done": "#10B981"
  };

  // Transform tasks to calendar events
  const events = tasks
    .filter(task => task.due_date || task.estimated_end_date)
    .map(task => {
      const taskDate = task.due_date || task.estimated_end_date;
      return {
        id: task.id,
        title: task.title,
        start: new Date(taskDate),
        end: new Date(taskDate),
        resource: task,
        allDay: true
      };
    });

  const eventStyleGetter = (event) => {
    const task = event.resource;
    const backgroundColor = statusColors[task.status] || '#3B82F6';
    
    return {
      style: {
        backgroundColor,
        borderRadius: '4px',
        opacity: 0.8,
        color: 'white',
        border: '0px',
        display: 'block',
        fontSize: '12px',
        padding: '2px 5px'
      }
    };
  };

  const messages = {
    allDay: 'Tüm gün',
    previous: 'Önceki',
    next: 'Sonraki',
    today: 'Bugün',
    month: 'Ay',
    week: 'Hafta',
    day: 'Gün',
    agenda: 'Ajanda',
    date: 'Tarih',
    time: 'Saat',
    event: 'Görev',
    noEventsInRange: 'Bu tarih aralığında görev yok',
    showMore: total => `+${total} daha`
  };

  const handleNavigate = (newDate) => {
    setDate(newDate);
  };

  const handleViewChange = (newView) => {
    setView(newView);
  };

  return (
    <div className="bg-white rounded-lg p-4" style={{ height: '600px' }}>
      <BigCalendar
        localizer={localizer}
        events={events}
        startAccessor="start"
        endAccessor="end"
        style={{ height: '100%' }}
        eventPropGetter={eventStyleGetter}
        onSelectEvent={(event) => onTaskClick(event.resource)}
        onSelectSlot={onSelectSlot}
        selectable
        messages={messages}
        views={['month', 'week', 'day', 'agenda']}
        view={view}
        onView={handleViewChange}
        date={date}
        onNavigate={handleNavigate}
      />
      
      {/* Legend */}
      <div className="mt-4 flex flex-wrap gap-4 text-sm">
        <div className="flex items-center gap-2">
          <span className="font-semibold">Durum:</span>
          <Badge className="bg-blue-500">Yapılacak</Badge>
          <Badge className="bg-purple-500">Devam Ediyor</Badge>
          <Badge className="bg-green-500">Tamamlandı</Badge>
        </div>
      </div>
    </div>
  );
}

export default CalendarView;
